module.exports = __webpack_public_path__ + "img/2.f8074f49.png";